<template>
  <div>
    <b-card class="mb-1 mt-2">
      <div class="card-title d-flex justify-content-between align-items-center">
        Settings
      </div>
      <div>
        <div v-for="setting in config" :key="setting.id" class="row">
          <div class="col-12"></div>
        </div>
        <b-tabs vertical nav-wrapper-class="nav-vertical">
          <b-overlay :show="isBusy" rounded="sm" :variant="skin">
            <b-tab v-for="setting in config" :key="setting.id">
              <template #title>
                <strong style="margin-right: auto">{{ setting.label }}</strong>
              </template>
              <b-card-text v-if="true" class="config">
                <b-card
                  v-for="children in setting.children"
                  :title="children.label"
                  :key="children.id"
                  sub-title=""
                >
                  <div class="row">
                    <b-form-group
                      v-for="item in children.children"
                      :key="item.id"
                      class="col-md-12"
                    >
                      <!-- #default="{ errors }" -->
                      <validation-provider
                        :name="item.key"
                        rules=""
                        #default="validationContext"
                      >
                        <b-form-group
                          v-if="item.type == 'number'"
                          :label="item.label"
                          label-for="input-1"
                        >
                          <b-form-input
                            :id="item.key"
                            :name="`custom_fields_data[${item.key}-${item.id}]`"
                            v-model="data_local[item.key]"
                            :value="
                              data_local.get_customfields_data[
                                'field_' + item.id
                              ]
                            "
                            :placeholder="item.label"
                            type="number"
                            :state="getValidationState(validationContext)"
                          />
                        </b-form-group>

                        <b-form-group
                          v-if="item.type == 'text'"
                          :label="item.label"
                          label-for="input-1"
                        >
                          <b-form-input
                            :id="item.key"
                            :name="`custom_fields_data[${item.key}-${item.id}]`"
                            v-model="data_local[item.key]"
                            :value="
                              data_local.get_customfields_data[
                                'field_' + item.id
                              ]
                            "
                            :placeholder="item.label"
                            type="text"
                            :state="getValidationState(validationContext)"
                          />
                        </b-form-group>
                        <b-form-group
                          v-if="item.type == 'radio'"
                          :label="item.label"
                          :label-for="item.key"
                        >
                          <div class="demo-inline-spacing">
                            <b-form-radio-group
                              :id="item.key"
                              v-model="data_local[item.key]"
                              :name="item.key"
                              :options="item.options"
                            />
                          </div>
                        </b-form-group>
                        <b-form-group
                          v-if="item.type == 'checkbox'"
                          :label="item.label"
                          label-for="input-1"
                        >
                          <div class="demo-inline-spacing">
                            <b-form-checkbox
                              v-model="data_local[item.key]"
                              switch
                              inline
                              :value="
                                data_local.get_customfields_data[
                                  'field_' + item.id
                                ]
                              "
                            >
                              Status
                            </b-form-checkbox>
                          </div>
                        </b-form-group>

                        <b-form-group
                          v-if="item.type == 'url'"
                          :label="item.label"
                          label-for="input-1"
                        >
                          <b-form-input
                            :id="item.key"
                            :name="`custom_fields_data[${item.key}-${item.id}]`"
                            v-model="data_local[item.key]"
                            :value="
                              data_local.get_customfields_data[
                                'field_' + item.id
                              ]
                            "
                            :placeholder="item.label"
                            type="url"
                            :state="getValidationState(validationContext)"
                          />
                        </b-form-group>

                        <b-form-group
                          v-if="item.type == 'file'"
                          :label="item.label"
                          :label-for="item.key"
                        >
                          <b-form-file
                            :id="item.key"
                            v-model="data_local[item.key]"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."
                          ></b-form-file>
                        </b-form-group>

                        <b-form-group
                          v-if="item.type == 'rating'"
                          :label="item.label"
                          label-for="input-1"
                        >
                          <div class="d-flex align-items-center">
                            <star-rating
                              v-model="
                                data_local.get_customfields_data[
                                  'field_' + item.id
                                ]
                              "
                              :show-rating="false"
                              :star-size="30"
                            ></star-rating>
                            <span
                              v-if="
                                data_local.get_customfields_data[
                                  'field_' + item.id
                                ]
                              "
                              :class="`rating-btn btn ${
                                ratingdescription[
                                  data_local.get_customfields_data[
                                    'field_' + item.id
                                  ]
                                ].class
                              }`"
                            >
                              {{
                                ratingdescription[
                                  data_local.get_customfields_data[
                                    "field_" + item.id
                                  ]
                                ].text
                              }}</span
                            >
                            <input
                              type="hidden"
                              v-model="
                                data_local.get_customfields_data[
                                  'field_' + item.id
                                ]
                              "
                              :name="`custom_fields_data[${item.name}-${item.id}]`"
                            />
                          </div>
                        </b-form-group>

                        <b-form-group
                          v-if="item.type == 'password'"
                          :label="item.label"
                          label-for="input-1"
                        >
                          <b-input-group
                            class="input-group-merge"
                            :class="
                              getValidationState(validationContext) > 0
                                ? 'is-invalid'
                                : null
                            "
                          >
                            <b-form-input
                              :id="item.name"
                              :name="`custom_fields_data[${item.name}-${item.id}]`"
                              v-model="data_local[item.key]"
                              :value="item.value"
                              :placeholder="item.label"
                              :type="passwordFieldType"
                              :state="getValidationState(validationContext)"
                            />
                            <b-input-group-append is-text>
                              <feather-icon
                                class="cursor-pointer"
                                :icon="passwordToggleIcon"
                                @click="togglePasswordVisibility"
                              />
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>

                        <b-form-group
                          v-if="item.type == 'textarea'"
                          :label="item.label"
                          label-for="input-1"
                        >
                          <b-form-textarea
                            :name="`custom_fields_data[${item.name}-${item.id}]`"
                            v-model="data_local[item.key]"
                            :value="
                              data_local.get_customfields_data[
                                'field_' + item.id
                              ]
                            "
                            trim
                            :placeholder="item.label"
                          />
                        </b-form-group>
                        <b-form-group
                          v-if="item.type == 'date'"
                          :label="item.label"
                          label-for="input-1"
                        >
                          <flat-pickr
                            :config="{
                              dateFormat: 'Y-m-d',
                            }"
                            :name="`custom_fields_data[${item.name}-${item.id}]`"
                            v-model="data_local[item.key]"
                            :value="
                              data_local.get_customfields_data[
                                'field_' + item.id
                              ]
                            "
                            class="form-control"
                            placeholder="Select Date.."
                          />
                        </b-form-group>

                        <small class="text-danger">{{
                          validationContext.errors[0]
                        }}</small>
                      </validation-provider>
                    </b-form-group>
                    <b-form-group class="col-md-12">
                      <b-button
                        type="submit"
                        class="min-w-200"
                        variant="success"
                        @click="formSubmitted"
                      >
                        Save
                      </b-button>
                    </b-form-group>
                  </div>
                </b-card>
              </b-card-text>
            </b-tab>
            <b-tab>
              <template #title>
                <strong style="margin-right: auto">Slack</strong>
              </template>

              <b-card title="Slack Integration">
                <b-overlay :show="slackLoading" rounded="sm" :variant="skin">

                  <!-- Not connected -->
                  <div v-if="!slackIntegration.connected">
                    <p class="text-muted mb-2">
                      Connect your Slack workspace so posts, comments and reactions
                      are automatically synced. Only needs to be done once by an admin.
                    </p>
                    <b-button variant="primary" @click="connectSlack">
                      <feather-icon icon="SlackIcon" class="mr-1" />
                      Connect Slack Workspace
                    </b-button>
                  </div>

                  <!-- Connected -->
                  <div v-else>
                    <b-alert show variant="success" class="d-flex align-items-center mb-2">
                      <feather-icon icon="CheckCircleIcon" size="18" class="mr-2" />
                      Connected to <strong class="mx-1">{{ slackIntegration.team_name }}</strong>
                    </b-alert>

                    <!-- Channel picker -->
                    <b-form-group label="Notification Channel" label-for="slack-channel">
                      <div class="d-flex align-items-center">
                        <v-select
                          id="slack-channel"
                          v-model="slackConfig.channel_id"
                          :options="slackChannels"
                          label="label"
                          :reduce="c => c.code"
                          :loading="slackChannelsLoading"
                          placeholder="Select a channel"
                          class="flex-grow-1"
                          @open="loadSlackChannels"
                          @input="onChannelSelect"
                        />
                        <b-button
                          variant="outline-secondary"
                          class="ml-1 px-2"
                          v-b-tooltip.hover
                          title="Refresh channel list"
                          :disabled="slackChannelsLoading"
                          @click="refreshSlackChannels"
                        >
                          <feather-icon icon="RefreshCwIcon" size="14" />
                        </b-button>
                      </div>
                    </b-form-group>

                    <!-- Toggles -->
                    <b-form-group>
                      <b-form-checkbox v-model="slackConfig.is_enabled" switch>
                        Enable Slack Integration
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group>
                      <b-form-checkbox v-model="slackConfig.notify_new_posts" switch>
                        Sync new posts to Slack
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group>
                      <b-form-checkbox v-model="slackConfig.notify_comments" switch>
                        Sync comments to Slack
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group>
                      <b-form-checkbox v-model="slackConfig.notify_reactions" switch>
                        Sync reactions to Slack
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group>
                      <b-form-checkbox v-model="slackConfig.allow_public_channel_replies" switch>
                        Allow Zircly Chatbot to reply in the channel (off = always reply by DM)
                      </b-form-checkbox>
                    </b-form-group>

                    <div class="d-flex mt-2">
                      <b-button variant="success" class="mr-2" @click="saveSlackConfig">
                        Save
                      </b-button>
                      <b-button variant="outline-danger" @click="disconnectSlack">
                        Disconnect
                      </b-button>
                    </div>
                  </div>

                </b-overlay>
              </b-card>
            </b-tab>
            <b-tab>
              <template #title>
                <strong style="margin-right: auto">Community </strong>
              </template>
              <b-card-text v-if="true" class="config">
                <b-card title="Community" key="Community" sub-title="">
                  <div>
                    <!-- Table Container Card -->
                    <b-button
                      variant="success"
                      size="sm"
                      v-b-modal.modal-channel-add
                    >
                      <span class="text-nowrap">Add Channel</span>
                    </b-button>
                    <b-card no-body class="mb-0 mt-2">
                      <div class="">
                        <b-list-group>
                          <b-list-group-item>
                            <b-row>
                              <b-col cols="2"> # </b-col>
                              <b-col cols="6"> Channel Name</b-col>
                              <b-col cols="4"> Action </b-col>
                            </b-row>
                          </b-list-group-item>
                          <b-list-group-item
                            v-for="(channel, index) in communityChannels"
                            :key="channel.hashid"
                          >
                            <b-row>
                              <b-col cols="2">
                                {{ ++index }}
                              </b-col>
                              <b-col cols="6">
                                {{ channel.channel_name }}
                              </b-col>
                              <b-col cols="4">
                                <feather-icon
                                  v-if="
                                    channel.channel_name != 'Community' &&
                                    channel.channel_name != 'Feedback Box'
                                  "
                                  @click="editChannel(channel)"
                                  v-b-modal.modal-channel-edit
                                  v-b-tooltip.hover
                                  title="Edit"
                                  icon="EditIcon"
                                  size="16"
                                  class="mr-1 cursor-pointer"
                                />
                                <b-dropdown
                                  v-if="
                                    channel.channel_name != 'Community' &&
                                    channel.channel_name != 'Feedback Box'
                                  "
                                  variant="link"
                                  size="sm"
                                  toggle-class="text-decoration-none"
                                  no-caret
                                >
                                  <template v-slot:button-content>
                                    <feather-icon
                                      icon="MoreVerticalIcon"
                                      size="16"
                                      class="text-body align-middle mr-25"
                                    />
                                  </template>
                                  <b-dropdown-item
                                    class="btn-sm p-0"
                                    @click="confirmDeleteRecord(channel)"
                                  >
                                    <feather-icon
                                      icon="TrashIcon"
                                      size="14"
                                      class="mr-50"
                                    />
                                    <span>Delete</span>
                                  </b-dropdown-item>
                                </b-dropdown>
                              </b-col>
                            </b-row>
                          </b-list-group-item>
                        </b-list-group>
                      </div>
                    </b-card>
                  </div>
                </b-card>
              </b-card-text>
            </b-tab>
            <b-tab>
              <template #title>
                <strong style="margin-right: auto">Logo Settings</strong>
              </template>
              <b-col md="12">
                <validation-observer ref="accountRules" tag="form">
                  <b-form autocomplete="off" id="company-form" class="p-0">
              <b-row class="uploadimg-row">
              <b-col sm="12" lg="6" class="py-1 my-50 border-right">
                <b-form-group label="Logo Light Theme" label-for="logo_for_light_theme">
                  <img v-if="data_local.light_logo" :src="data_local.light_logo" alt="Light Logo" />
                  <b-media-body class="">
                <div
                  v-show="imageSrc"
                  class="my-2 w-64 h-64 object-fill mx-auto position-relative"
                  style="
                    object-fit: fill;
                    width: 16rem;
                    height: 16rem;
                    margin-left: auto;
                    margin-right: auto;
                  "
                >
                  <img
                    style="display: block; max-width: 100%"
                    class="block max-w-full"
                    ref="img"
                    :src="imageSrc"
                  />
                  <button
                    class="btn btn-gray text-danger close-crop-btn"
                    @click.stop.prevent="fileCleared('image1')"
                  >
                    <feather-icon icon="XIcon" size="22" />
                  </button>
                </div>

                <div class="btn-crop-container mt-2">
                  <b-button
                    v-if="!imageSrc"
                    class="btn btn-blue w-32"
                    variant="primary"
                    pill
                    @click.stop.prevent="imageInput.click()"
                  >
                  Upload Photo
                  </b-button>
                  <b-button
                    v-if="imageSrc && !cropped"
                    class="btn btn-gray w-32"
                    variant="primary"
                    pill
                    @click.stop.prevent="handleCropImage('image1')"
                  >
                    Crop
                  </b-button>

                  <input
                    type="file"
                    ref="imageInput"
                    accept=".svg,.png"
                    @change="fileChanged('image1',$event)"
                    :style="{ display: 'none' }"
                  />

                  <b-button
                    class="btn btn-gray w-32 ml-2"
                    variant="outline-danger"
                    pill
                    @click.stop.prevent="removeLogo('light_logo')"
                  >
                    Remove
                  </b-button>
                </div>
              </b-media-body>
                  <small class="text-secondary flex items-center d-block mt-50">
                    <feather-icon icon="AlertCircleIcon" class="mr-25" />
                    File size should be 40x42 px and  less than 1MB and allowed formats are
                    <b>.svg, .png</b>
                  </small>
                  <!-- <b-img
                    v-if="data_local.company_logo"
                    ref="previewEl"
                    rounded
                    :src="data_local.company_logo"
                    height="80"
                  /> -->
                </b-form-group>
              </b-col>
              <b-col sm="12" lg="6" class="py-1 my-50">
                <b-form-group label="Logo Name Light Theme" label-for="logo_name_light_theme">
                <img v-if="data_local.light_name_logo" :src="data_local.light_name_logo" alt="Light Logo" />
                  <b-media-body class="">
                <div
                  v-show="imageSrc1"
                  class="my-2 w-64 h-64 object-fill mx-auto position-relative"
                  style="
                    object-fit: fill;
                    width: 16rem;
                    height: 16rem;
                    margin-left: auto;
                    margin-right: auto;
                  "
                >
                  <img
                    style="display: block; max-width: 100%"
                    class="block max-w-full"
                    ref="img1"
                    :src="imageSrc1"
                  />
                  <button
                    class="btn btn-gray text-danger close-crop-btn"
                    @click.stop.prevent="fileCleared('image2')"
                  >
                    <feather-icon icon="XIcon" size="22" />
                  </button>
                </div>

                <div class="btn-crop-container mt-2">
                  <b-button
                    v-if="!imageSrc1"
                    class="btn btn-blue w-32"
                    variant="primary"
                    pill
                    @click.stop.prevent="imageInput1.click()"
                  >
                  Upload Photo
                  </b-button>
                  <b-button
                    v-if="imageSrc1 && !cropped1"
                    class="btn btn-gray w-32"
                    variant="primary"
                    pill
                    @click.stop.prevent="handleCropImage('image2')"
                  >
                    Crop
                  </b-button>

                  <input
                    type="file"
                    ref="imageInput1"
                    accept=".svg,.png"
                    @change="fileChanged('image2',$event)"
                    :style="{ display: 'none' }"
                  />

                  <b-button
                    class="btn btn-gray w-32 ml-2"
                    variant="outline-danger"
                    pill
                    @click.stop.prevent="removeLogo('light_name_logo')"
                  >
                    Remove
                  </b-button>
                </div>
              </b-media-body>
                  <small class="text-secondary flex items-center d-block mt-75">
                    <feather-icon icon="AlertCircleIcon" class="mr-25" />
                    File size should be 96x55 px and less than 1MB and allowed formats are
                    <b>.svg, .png</b>
                  </small>
                  <!-- <b-img
                    v-if="data_local.company_logo"
                    ref="previewEl"
                    rounded
                    :src="data_local.company_logo"
                    height="80"
                  /> -->
                </b-form-group>
              </b-col>
              </b-row>
              <b-row class="uploadimg-row border-top">
              <b-col sm="12" lg="6" class="py-1 my-50 border-right">
                <b-form-group label="Logo Dark Theme" label-for="logo_for_dark_theme">
                  <img v-if="data_local.dark_logo" :src="data_local.dark_logo" alt="Dark Logo" />
                  <b-media-body class="">
                <div
                  v-show="imageSrc2"
                  class="my-2 w-64 h-64 object-fill mx-auto position-relative"
                  style="
                    object-fit: fill;
                    width: 16rem;
                    height: 16rem;
                    margin-left: auto;
                    margin-right: auto;
                  "
                >
                  <img
                    style="display: block; max-width: 100%"
                    class="block max-w-full"
                    ref="img2"
                    :src="imageSrc2"
                  />
                  <button
                    class="btn btn-gray text-danger close-crop-btn"
                    @click.stop.prevent="fileCleared('image3')"
                  >
                    <feather-icon icon="XIcon" size="22" />
                  </button>
                </div>

                <div class="btn-crop-container mt-2">
                  <b-button
                    v-if="!imageSrc2"
                    class="btn btn-blue w-32"
                    variant="primary"
                    pill
                    @click.stop.prevent="imageInput2.click()"
                  >
                    Upload Photo
                  </b-button>
                  <b-button
                    v-if="imageSrc2 && !cropped2"
                    class="btn btn-gray w-32"
                    variant="primary"
                    pill
                    @click.stop.prevent="handleCropImage('image3')"
                  >
                    Crop
                  </b-button>

                  <input
                    type="file"
                    ref="imageInput2"
                    accept=".svg,.png"
                    @change="fileChanged('image3',$event)"
                    :style="{ display: 'none' }"
                  />

                  <b-button
                    class="btn btn-gray w-32 ml-2"
                    variant="outline-danger"
                    pill
                    @click.stop.prevent="removeLogo('dark_logo')"
                  >
                    Remove
                  </b-button>
                </div>
              </b-media-body>
                  <small class="text-secondary flex items-center d-block mt-75">
                    <feather-icon icon="AlertCircleIcon" class="mr-25" />
                    File size should be 40x42 px and less than 1MB and allowed formats are
                    <b>.svg, .png</b>
                  </small>
                  <!-- <b-img
                    v-if="data_local.company_logo"
                    ref="previewEl"
                    rounded
                    :src="data_local.company_logo"
                    height="80"
                  /> -->
                </b-form-group>
              </b-col>
              <b-col sm="12" lg="6" class="py-1 my-50">
                <b-form-group label="Logo Name Dark Theme" label-for="logo_name_dask_theme">
                  <img v-if="data_local.dark_name_logo" :src="data_local.dark_name_logo" alt="Dark Logo" />
              <b-media-body class="">
                <div
                  v-show="imageSrc3"
                  class="my-2 w-64 h-64 object-fill mx-auto position-relative"
                  style="
                    object-fit: fill;
                    width: 16rem;
                    height: 16rem;
                    margin-left: auto;
                    margin-right: auto;
                  "
                >
                  <img
                    style="display: block; max-width: 100%"
                    class="block max-w-full"
                    ref="img3"
                    :src="imageSrc3"
                  />
                  <button
                    class="btn btn-gray text-danger close-crop-btn"
                    @click.stop.prevent="fileCleared('image4')"
                  >
                    <feather-icon icon="XIcon" size="22" />
                  </button>
                </div>

                <div class="btn-crop-container mt-2">
                  <b-button
                    v-if="!imageSrc3"
                    class="btn btn-blue w-32"
                    variant="primary"
                    pill
                    @click.stop.prevent="imageInput3.click()"
                  >
                    Upload Photo
                  </b-button>
                  <b-button
                    v-if="imageSrc3 && !cropped3"
                    class="btn btn-gray w-32"
                    variant="primary"
                    pill
                    @click.stop.prevent="handleCropImage('image4')"
                  >
                    Crop
                  </b-button>

                  <input
                    type="file"
                    ref="imageInput3"
                    accept=".svg,.png"
                    @change="fileChanged('image4',$event)"
                    :style="{ display: 'none' }"
                  />

                  <b-button
                    class="btn btn-gray w-32 ml-2"
                    variant="outline-danger"
                    pill
                    @click.stop.prevent="removeLogo('dark_name_logo')"
                  >
                    Remove
                  </b-button>
                </div>
              </b-media-body>
                  <small class="text-secondary flex items-center d-block mt-50">
                    <feather-icon icon="AlertCircleIcon" class="mr-25" />
                    File size should be 96x55 px and  less than 1MB and allowed formats are
                    <b>.svg, .png</b>
                  </small>
                  <!-- <b-img
                    v-if="data_local.company_logo"
                    ref="previewEl"
                    rounded
                    :src="data_local.company_logo"
                    height="80"
                  /> -->
                </b-form-group>
              </b-col>
            </b-row>
                  </b-form>
                </validation-observer>
          </b-col>
            </b-tab>
          </b-overlay>
        </b-tabs>
      </div>
    </b-card>

    <b-modal
      id="modal-channel-add"
      ref="modal"
      title="Add new Channel"
      @ok="addChannel"
      @show="resetModal"
    >
      <div>
        <b-form-group label-for="channelName" label="Channel Name">
          <b-form-input
            id="channelName"
            v-model="community_data.channel_name"
            placeholder="Channel Name"
            name="name"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          label-for="channelDescription"
          label="Channel Description"
        >
          <b-form-textarea
            id="channelDescription"
            v-model="community_data.description"
            placeholder="Channel Description"
            name="description"
          >
          </b-form-textarea>
        </b-form-group>
        <b-form-group
          label-for="ChannelColor"
          label="Channel Color"
        >
        <colour-picker
        v-model="community_data.channel_color" :color="color" :colorOptions="colors" />
        
        </b-form-group>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="danger" @click="cancel()">
          Cancel
        </b-button>
        <b-button size="sm" variant="success" @click="ok()"> Save </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-channel-edit"
      ref="modal-channel-edit"
      title="Channel Edit"
      @ok="updateChannel"
    >
      <div>
        <b-form-group label-for="channelName" label="Channel Name">
          <b-form-input
            id="channelName"
            v-model="community_data.channel_name"
            placeholder="Channel Name"
            name="name"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          label-for="channelDescription"
          label="Channel Description"
        >
          <b-form-textarea
            id="channelDescription"
            v-model="community_data.description"
            placeholder="Channel Description"
            name="description"
          >
          </b-form-textarea>
        </b-form-group>
        <b-form-group
          label-for="ChannelColor"
          label="Channel Color"
        >
        <colour-picker
        v-model="community_data.channel_color" :color="color" :colorOptions="colors"/>
        
        </b-form-group>
        
      </div>

      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="danger" @click="cancel()">
          Cancel
        </b-button>
        <b-button size="sm" variant="success" @click="ok()"> Update </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";

// Import Vue FilePond
import vueFilePond from "vue-filepond";
// Import plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm";
import FilePondPluginImagePreview from "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm";
import FilePondPluginImageValidateSize from "filepond-plugin-image-validate-size";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileEncode from "filepond-plugin-file-encode";

// Create FilePond component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginImageValidateSize,
  FilePondPluginFileValidateSize,
  FilePondPluginFileEncode
);

import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BForm,
  BFormCheckbox,
  BInputGroup,
  VBTooltip,
  BInputGroupAppend,
  BCardText,
  BTabs,
  BTab,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import {
  ref,
  watchEffect,
  onMounted,
  onUnmounted,
  watch, } from "@vue/composition-api";
import { required, email, numeric } from "@validations";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import store from "@/store";
import settingsStoreModule from "./settingsStoreModule";
import bomb from "@/libs/bomb/bomb";
import Cropper from "cropperjs";
import StarRating from "vue-star-rating";
import formValidation from "@core/comp-functions/forms/form-validation";
import axios from "@axios";
import Vue from "vue";
import VueCookies from "vue-cookies";
import ColourPicker from "@/components/CustomColorPicker.vue";
Vue.use(VueCookies);

export default {
  components: {
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BForm,
    BFormCheckbox,
    BInputGroupAppend,
    BInputGroup,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    StarRating,
    flatPickr,
    AppCollapse,
    AppCollapseItem,
    BCardText,
    BTabs,
    BTab,
    FilePond,
    ColourPicker
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      skin: store.state.appConfig.layout.skin,
      data_local: {
        light_logo:"",
        light_name_logo:"",
        dark_logo:"",
        dark_name_logo:""
      },
      config: "",
      all_notifications: false,
      allSelected: false,
      isBusy: false,
      redirectEmailNotification: "",
      data_local: {
        title: "",
        get_customfields_data: [],
      },
      formData: {
        url: "settings",
      },
      subscriptions: [],
      communityChannels: [],
      searchQuery: "",
      community_data: {
        channel_name: "",
        description: "",
        channel_color:"",
      },
      color:'#218F17',
      colors:[
        '#137BB6',
        '#218F17',
        '#DB9901',
        '#1F767E',
        '#A81496',
        '#223F58',
        '#36464E',
        '#9C4E22',
      ],
      filterByType: "",
      typeOption: [
        {
          code: "one",
          label: "One",
        },
        {
          code: "many",
          label: "Many",
        },
      ],
      slackLoading: false,
      slackChannelsLoading: false,
      slackIntegration: { connected: false },
      slackChannels: [],
      selectedChannelWarning: false,
      slackConfig: {
        channel_id:       null,
        channel_name:     '',
        is_enabled:       true,
        notify_new_posts: true,
        notify_comments:  true,
        notify_reactions: true,
        allow_public_channel_replies: false,
      },
    };
  },
  mixins: [togglePasswordVisibility],
  setup() {
    const imageInput = ref(null);
    const imageInput1 = ref(null);
    const imageInput2 = ref(null);
    const imageInput3 = ref(null);

    const selectedFile = ref(null);
    const selectedFile1 = ref(null);
    const selectedFile2 = ref(null);
    const selectedFile3 = ref(null);

     const imageSrc = ref(null);
      const imageSrc1 =  ref(null);
      const imageSrc2 =  ref(null);
      const imageSrc3 = ref(null);


      let cropper =    null;
      let cropper1 =   null;
      let cropper2 =   null;
      let cropper3 =   null;


     const cropped = ref(false);
      const cropped1 =   ref(false);
      const cropped2 =   ref(false);
      const cropped3 =   ref(false);

      const img = ref(null);
      const img1 = ref(null);
      const img2 = ref(null);
      const img3 = ref(null);


      

    const fileReader = new FileReader();

    fileReader.onload = (event) => {
      imageSrc.value = event.target.result;
      imageSrc1.value = event.target.result;
      imageSrc2.value = event.target.result;
      imageSrc3.value = event.target.result;

    };


const handleCropImage = (image) => {
  if (image === "image1" && cropper) {
    if (cropper.getCroppedCanvas) {
    console.log(selectedFile.value )

      cropper.getCroppedCanvas({
        width: 40,
        height: 42,
        fillColor:"#fff",
        imageSmoothingQuality: 'high',
      }).toBlob((blob) => {
        selectedFile.value = blob;
        cropped.value = true;
      }, "image/jpeg",{ transparency: true });
    } else {
      console.error("getCroppedCanvas method not available in cropper");
    }
  } else if (image === "image2" && cropper1) {

    if (cropper1.getCroppedCanvas) {
      cropper1.getCroppedCanvas({
        width: 96,
        height: 55,
        fillColor:"#fff",
        imageSmoothingQuality: 'high',
      }).toBlob((blob) => {
        selectedFile1.value = blob;
        cropped1.value = true;
      }, "image/jpeg");

    console.log(selectedFile1.value )

    } else {
      console.error("getCroppedCanvas method not available in cropper1");
    }
  } else if (image === "image3" && cropper2) {
    if (cropper2.getCroppedCanvas) {
      cropper2.getCroppedCanvas({
        width: 40,
        height: 42,
        fillColor:"#191C24",
        imageSmoothingQuality: 'high',
      }).toBlob((blob) => {
        selectedFile2.value = blob;
        cropped2.value = true;
      }, "image/jpeg");
    console.log(selectedFile2.value )

    } else {
      console.error("getCroppedCanvas method not available in cropper2");
    }
  } else if (image === "image4" && cropper3) {
    if (cropper3.getCroppedCanvas) {
      cropper3.getCroppedCanvas({
        width: 96,
        height: 55,
        fillColor:"#191C24",
        imageSmoothingQuality: 'high',
      }).toBlob((blob) => {
        selectedFile3.value = blob;
        cropped3.value = true;
      }, "image/jpeg");
    console.log(selectedFile3.value )

    } else {
      console.error("getCroppedCanvas method not available in cropper3");
    }
  } else {
    console.error("Invalid image or cropper instance:", image, cropper, cropper1, cropper2, cropper3);
  }
};


    const fileChanged = (inputKey, e) => {
    const files = e.target.files || e.dataTransfer.files;
    if (files.length) {
      switch (inputKey) {
        case 'image1':
        selectedFile.value = files[0];
        break;
        case 'image2':
        selectedFile1.value = files[0];
        break;
        case 'image3':
        selectedFile2.value = files[0];
        break;
        case 'image4':
        selectedFile3.value = files[0];
        break;
        default:
        break;
      }
    }
  }

  const fileCleared = (fileNumber) => {
     console.log(fileNumber)
      switch(fileNumber) {
        case "image1":
          console.log('hwwd')
          selectedFile.value = null;
          cropped.value = false;
          break
        case "image2":
          selectedFile1.value = null
          cropped1.value = false
          break
        case "image3":
          selectedFile2.value = null
          cropped2.value = false
          break
        case "image4":
          selectedFile3.value = null
          cropped3.value = false
          break
        default:
          selectedFile.value = null
          cropped.value = false
          break
      }
    }




    const USER_APP_STORE_MODULE_NAME = "app-settings";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, settingsStoreModule);

    // UnRegister on leave
    onMounted(() => {
      cropper = new Cropper(img.value, {
        aspectRatio: 1,
        minCropBoxWidth: 256,
        minCropBoxHeight: 256,
        dragMode: "move",
        background: false,
        cropBoxMovable: false,
        cropBoxResizable: false,
        viewMode: 1, // Ensure the image cannot be moved outside the cropping box
        autoCropArea: 1, // Ensure the crop box covers the entire image initially
      });
      cropper1 = new Cropper(img1.value, {
        aspectRatio: 96/55,
        minCropBoxWidth: 256,
        minCropBoxHeight: 256,
        dragMode: "move",
        background: false,
        cropBoxMovable: false,
        cropBoxResizable: false,
        viewMode: 1,
        autoCropArea: 1,
 
      }); 
      cropper2 = new Cropper(img2.value, {
        aspectRatio: 1,
        minCropBoxWidth: 256,
        minCropBoxHeight: 256,
        dragMode: "move",
        background: false,
        cropBoxMovable: false,
        cropBoxResizable: false,
        viewMode: 1, // Ensure the image cannot be moved outside the cropping box
        autoCropArea: 1, // Ensure the crop box covers the entire image initially
      }); 
      cropper3 = new Cropper(img3.value, {
        aspectRatio: 96/55,
        minCropBoxWidth: 256,
        minCropBoxHeight: 256,
        dragMode: "move",
        background: false,
        cropBoxMovable: false,
        cropBoxResizable: false,
        viewMode: 1, // Ensure the image cannot be moved outside the cropping box
        autoCropArea: 1, // Ensure the crop box covers the entire image initially
      });

      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    onUnmounted(() => {
      cropper.destroy();
      cropper1.destroy();
      cropper2.destroy();
      cropper3.destroy();
    });

    watchEffect(() => {
  if (selectedFile.value) {
    const fileReader1 = new FileReader();
    fileReader1.onload = (event) => {
      imageSrc.value = event.target.result;
    };
    fileReader1.readAsDataURL(selectedFile.value);
  } else {
    imageSrc.value = null;
  }
});

watchEffect(() => {
  if (selectedFile1.value) {
    const fileReader2 = new FileReader();
    fileReader2.onload = (event) => {
      imageSrc1.value = event.target.result;
    };
    fileReader2.readAsDataURL(selectedFile1.value);
  } else {
    imageSrc1.value = null;
  }
});

watchEffect(() => {
  if (selectedFile2.value) {
    const fileReader3 = new FileReader();
    fileReader3.onload = (event) => {
      imageSrc2.value = event.target.result;
    };
    fileReader3.readAsDataURL(selectedFile2.value);
  } else {
    imageSrc2.value = null;
  }
});

watchEffect(() => {
  if (selectedFile3.value) {
    const fileReader4 = new FileReader();
    fileReader4.onload = (event) => {
      imageSrc3.value = event.target.result;
    };
    fileReader4.readAsDataURL(selectedFile3.value);
  } else {
    imageSrc3.value = null;
  }
});

watch(
      imageSrc,
      () => {
        if (imageSrc.value) {
          cropper.replace(imageSrc.value);
        }
      },
      {
        flush: "post",
      }
    );
watch(
      imageSrc1,
      () => {
        if (imageSrc1.value) {
          cropper1.replace(imageSrc1.value);
        }
      },
      {
        flush: "post",
      }
    );
watch(
      imageSrc2,
      () => {
        if (imageSrc2.value) {
          cropper2.replace(imageSrc2.value);
        }
      },
      {
        flush: "post",
      }
    );
watch(
      imageSrc3,
      () => {
        if (imageSrc3.value) {
          cropper3.replace(imageSrc3.value);
        }
      },
      {
        flush: "post",
      }
    );

    const { refFormObserver, getValidationState, resetForm } = formValidation();

    return {
      refFormObserver,
      getValidationState,
      resetForm,
      imageInput,
      imageInput1,
      imageInput2,
      imageInput3,
      selectedFile,
      selectedFile1,
      selectedFile2,
      selectedFile3,
      fileChanged,
      fileCleared,
      imageSrc,
      imageSrc1,
      imageSrc2,
      imageSrc3,
      img,
      img1,
      img2,
      img3,
      handleCropImage,
      cropped,
      cropped1,
      cropped2,
      cropped3
    };
  },

  created() {
    this.getModuleData();
    this.getCommunitychannels();
    this.loadSlackIntegration();

    // If coming back from Slack OAuth, show result
    const params = new URLSearchParams(window.location.search);
    if (params.get('slack_success')) {
      this.$toast({ component: ToastificationContent, props: {
        title: 'Slack connected!', icon: 'CheckIcon', variant: 'success',
      }}, { timeout: 3000, position: 'bottom-center', hideProgressBar: true });
      this.$router.replace({ query: {} });
      this.loadSlackIntegration();
    }
    if (params.get('slack_error')) {
      this.$toast({ component: ToastificationContent, props: {
        title: 'Slack error: ' + params.get('slack_error'),
        icon: 'XCircleIcon', variant: 'danger',
      }}, { timeout: 3000, position: 'bottom-center', hideProgressBar: true });
      this.$router.replace({ query: {} });
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  watch: {
    searchQuery(val) {
      this.getUserEmailSubscriptions();
    },
    filterByType(val) {
      this.getUserEmailSubscriptions();
    },
  },
  methods: {
    onChannelSelect(channelId) {
      const selected = this.slackChannels.find(c => c.code === channelId);
      this.selectedChannelWarning = selected
        && selected.is_private
        && !selected.is_member;
    },
    refreshSlackChannels() {
      this.slackChannels = []; // clear cache
      this.loadSlackChannels(); // reload from API
    },
    connectSlack() {
      // Redirect to backend which starts OAuth — your axios instance
      // already sends the tenant header so backend knows who this is
      //alert(`${axios.defaults.baseURL}/slack/redirect`)

      this.$store
        .dispatch("app/get", { url: '/slack/redirect'})
        .then((res) => {
          if (res.data.status && res.data.redirect_url) {
            //alert(res.data.redirect_url)
            window.location.href = res.data.redirect_url;
          } else {
            this.$toast({ component: ToastificationContent, props: {
              title: 'Unexpected response from server', icon: 'AlertCircleIcon', variant: 'warning',
            }}, { timeout: 3000, position: 'bottom-center', hideProgressBar: true });
          }
        })
        .catch((error) => {
          this.$toast({ component: ToastificationContent, props: {
            title: 'Slack connection failed', icon: 'XCircleIcon', variant: 'danger',
            text: error.response && error.response.data && error.response.data.message ? error.response.data.message : '',
          }}, { timeout: 3000, position: 'bottom-center', hideProgressBar: true });
        });
    },
    async loadSlackIntegration() {
      this.slackLoading = true;
      try {
        const { data } = await axios.get('/slack/integration');
        this.slackIntegration = data;
        if (data.connected) {
          this.slackConfig.channel_id       = data.channel_id;
          this.slackConfig.channel_name     = data.channel_name;
          this.slackConfig.is_enabled       = data.is_enabled;
          this.slackConfig.notify_new_posts = data.notify_new_posts;
          this.slackConfig.notify_comments  = data.notify_comments;
          this.slackConfig.notify_reactions = data.notify_reactions;
          this.slackConfig.allow_public_channel_replies = data.allow_public_channel_replies;
          this.loadSlackChannels();
        }
      } catch (e) {
        // not connected yet — that's fine
      } finally {
        this.slackLoading = false;
      }
    },

    async loadSlackChannels() {
      if (this.slackChannels.length) return; // already loaded
      this.slackChannelsLoading = true;
      try {
        const { data } = await axios.get('/slack/channels');
        this.slackChannels = data;
      } catch (e) {
        this.$toast({ component: ToastificationContent, props: {
          title: 'Could not load channels', icon: 'AlertCircleIcon', variant: 'danger',
        }}, { timeout: 3000, position: 'bottom-center', hideProgressBar: true });
      } finally {
        this.slackChannelsLoading = false;
      }
    },

    async saveSlackConfig() {
      // Attach channel_name from selected option
      const selected = this.slackChannels.find(c => c.code === this.slackConfig.channel_id);
      this.slackConfig.channel_name = selected ? selected.label : '';

      try {
        await axios.post('/slack/integration', this.slackConfig);
        this.$toast({ component: ToastificationContent, props: {
          title: 'Slack settings saved!', icon: 'CheckIcon', variant: 'success',
        }}, { timeout: 2000, position: 'bottom-center', toastClassName: 'radius-8 successful-info', hideProgressBar: true });
      } catch (e) {
        this.$toast({ component: ToastificationContent, props: {
          title: 'Save failed', icon: 'XCircleIcon', variant: 'danger',
        }}, { timeout: 2000, position: 'bottom-center', toastClassName: 'radius-8 error-info', hideProgressBar: true });
      }
    },

    async disconnectSlack() {
      this.$swal({
        title: 'Disconnect Slack?',
        text: 'Posts will no longer sync to Slack.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, disconnect',
        customClass: { confirmButton: 'btn btn-danger', cancelButton: 'btn btn-outline-secondary ml-1' },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          await axios.delete('/slack/disconnect');
          this.slackIntegration = { connected: false };
          this.slackChannels    = [];
          this.slackConfig      = {
            channel_id: null, channel_name: '', is_enabled: true,
            notify_new_posts: true, notify_comments: true, notify_reactions: true,
          };
          this.$toast({ component: ToastificationContent, props: {
            title: 'Slack disconnected', icon: 'CheckIcon', variant: 'success',
          }}, { timeout: 2000, position: 'bottom-center', hideProgressBar: true });
        }
      });
    },
    formSubmitted() {
      const self = this;

      this.isBusy = true;

      self.formData.url = "settings/config";
      self.formData.params = self.data_local;

      this.$store
        .dispatch("app/store", self.formData)
        .then((res) => {
          this.isBusy = false;
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Config Updated",
          //     icon: "CheckIcon",
          //     variant: "success",
          //     text: res.data.message,
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Config Updated',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });
        })
        .catch((error) => {
          this.isBusy = false;
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Oops! Config Updation Failed",
          //     icon: "XCircleIcon",
          //     variant: "danger",
          //     text: error,
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Oops! Config Updation Failed',
                icon: 'XCircleIcon',
                variant: 'danger',
                text: error,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
        });
    },
    validationForm() {
      const self = this;

      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    getModuleData() {
      const self = this;
      let params = [];
      params.url = "settings/create";
      self.$store
        .dispatch("app/get", params)
        .then((res) => {
          self.config = res.data.data;
          self.config.forEach(function (item) {
            item.children.forEach(function (children) {
              children.children.forEach(function (field) {
                if (field.type != "file") {
                  self.data_local[field.key] = field.value;
                }
                if (field.type == "radio") {
                  console.log(field);
                }
              });
            });
          });
        })
        .catch((error) => {
          // self.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Oops! Config Getting Failed",
          //     icon: "BellIcon",
          //     variant: "danger",
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: `Oops! Config Getting Failed`,
                icon:'BellIcon',
                variant : 'danger',
                hideClose: true,
                
              },
                  },
                  {
              timeout : 3000,
              position : 'bottom-center',
              toastClassName:"error-info",
              hideProgressBar : true,
                  })
        });
    },
    getCommunitychannels() {
      const self = this;
      let params = [];
      this.isBusy = true;
      params.url = "community-channels";
      self.$store
        .dispatch("app/get", params)
        .then((res) => {
          self.communityChannels = res.data.data;
          this.isBusy = false;
        })
        .catch((error) => {
          this.isBusy = false;
          // self.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Oops! community Channels",
          //     icon: "BellIcon",
          //     variant: "danger",
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: `Oops! community Channels`,
                icon:'BellIcon',
                variant : 'danger',
                hideClose: true,
                
              },
                  },
                  {
              timeout : 3000,
              position : 'bottom-center',
              toastClassName:"error-info",
              hideProgressBar : true,
                  })
        });
    },
    addChannel() {
      const self = this;
      let data = [];
      data.url = "community-channels";
      data.params = {
        channel_name: this.community_data.channel_name,
        description: this.community_data.description,
        channel_color: this.community_data.channel_color,
      };
      self.$store
        .dispatch("app/store", data)
        .then((res) => {
          this.community_data.channel_name = "";
          this.community_data.description = "";
          this.community_data.channel_color = "";
          this.getCommunitychannels();
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Channel Added successfully",
          //     icon: "BellIcon",
          //     variant: "success",
          //   },
          // });
          this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Channel Added successfully',
          icon: 'CheckIcon',
          variant: 'success',
          hideClose: true,
        },
      }, {
        timeout: 2000, 
        position: 'bottom-center',
        toastClassName:"successful-info",
        hideProgressBar : true,
      }); 
        })
        .catch((error) => {
          // self.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Oops! Adding Channels Failed",
          //     icon: "BellIcon",
          //     variant: "danger",
          //     text: error,
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Oops! Adding Channels Failed',
                icon: 'BellIcon',
                variant: 'danger',
                text: error,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
        });
    },
    updateChannel() {
      const self = this;
      let data = [];
      data.url = "community-channels/" + this.community_data.hashid;
      data.params = {
        channel_name: this.community_data.channel_name,
        description: this.community_data.description,
        channel_color: this.community_data.channel_color,
        _method: "PATCH",
      };
      self.$store
        .dispatch("app/update", data)
        .then((res) => {
          this.community_data.channel_name = "";
          this.community_data.description = "";
          this.community_data.channel_color = "";
          this.getCommunitychannels();
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Channel Updated successfully",
          //     icon: "BellIcon",
          //     variant: "success",
          //   },
          // });
          this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Channel Updated successfully',
          icon: 'CheckIcon',
          variant: 'success',
          hideClose: true,
        },
      }, {
        timeout: 2000, 
        position: 'bottom-center',
        toastClassName:"successful-info",
        hideProgressBar : true,
      }); 
        })
        .catch((error) => {
          // self.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Oops! Adding Channels Failed",
          //     icon: "BellIcon",
          //     variant: "danger",
          //     text: error,
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: `Oops! Adding Channels Failed`,
                icon:'BellIcon',
                variant : 'danger',
                hideClose: true,
                text: error,
                
              },
                  },
                  {
              timeout : 3000,
              position : 'bottom-center',
              toastClassName:"radius-8 error-info",
              hideProgressBar : true,
                  })
        });
    },
    removeChannel(channel) {
      const self = this;

      this.isBusy = true;
      self.formData.url = "community-channels/" + channel.hashid;

      this.$store
        .dispatch("app/delete", self.formData)
        .then((res) => {
          // self.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Channel Removed",
          //     icon: "BellIcon",
          //     variant: "success",
          //     text: res.data.message,
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Channel Removed',
                icon: 'BellIcon',
                variant: 'success',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });
          this.getCommunitychannels();
          this.isBusy = false;
        })
        .catch((error) => {
          this.isBusy = false;
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Oops! Channel Removing Failed",
          //     icon: "BellIcon",
          //     variant: "danger",
          //     text: error.text,
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Oops! Channel Removing Failed',
                icon: 'BellIcon',
                variant: 'danger',
                text: error.text,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
                  
        });
    },
    editChannel(channel) {
      const self = this;
      self.community_data = {
        hashid: channel.hashid,
        channel_name: channel.channel_name,
        description: channel.description,
        channel_color: channel.channel_color,
      };
    },
    resetModal() {
      const self = this;
      self.community_data = {
        hashid: "",
        channel_name: "",
        description: "",
        channel_color: "",
      };
    },
    confirmDeleteRecord(data) {
      this.$swal({
        title: "Are you sure?",
        text: `You want to delete ${data.channel_name}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.removeChannel(data);
        }
      });
    },
    async getImageSize(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          resolve({ width: img.width, height: img.height });
        };
        img.onerror = (error) => {
          reject(error);
        };
        img.src = e.target.result;
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  },
//  async formSubmitted() {
//     const self = this;
//     const formData = new FormData(document.getElementById("company-form"));
//     formData.delete("files[]"); // data is the name of the original input file; import to delete

//       const files = self.$refs.pond.getFiles();

//       const keys = Object.keys(self.$refs.pond.getFiles());

//       for (let i = 0; i < keys.length; i += 1) {
//         formData.append("company_logo", files[i].file);
      
//       }
//       if(this.selectedFile != null){
//       formData.append("light_logo", this.selectedFile);
//       }
//       if(this.selectedFile1 != null){
//       formData.append("light_name_logo", this.selectedFile1);
//       }
//       if(this.selectedFile2 != null){
//       formData.append("dark_logo", this.selectedFile2);
//       }
//       if(this.selectedFile3 != null){
//       formData.append("dark_name_logo", this.selectedFile3);
//       }

//        this.$store
//         .dispatch("app-setting/updateSettings", {
//           data: formData,
//         })
//         .then((res) => {
//           if (res.data.success) {
//             this.$toast({
//               component: ToastificationContent,
//               props: {
//                 title: "Company Settings Updated",
//                 icon: "BellIcon",
//                 variant: "success",
//                 text: res.data.message,
//               },
//             });
//             // this.$router.push("/settings");
//           } else {
//             this.$toast({
//               component: ToastificationContent,
//               props: {
//                 title: "Oops! Company updating Failed",
//                 icon: "BellIcon",
//                 variant: "danger",
//                 text: res.data.message,
//               },
//             });
//           }
//         })
//         .catch((error) => {
//           this.$toast({
//             component: ToastificationContent,
//             props: {
//               title: "Oops! Company updating Failed",
//               icon: "BellIcon",
//               variant: "danger",
//               text: error,
//             },
//           });
//         });
//     },
    validationForm() {
      const self = this;
      if (
        self.data_local.company_logo === "" &&
        this.$refs.pond.getFiles().length === 0
      ) {
        // self.$toast({
        //   component: ToastificationContent,
        //   props: {
        //     title: "Logo Needed",
        //     icon: "BellIcon",
        //     variant: "danger",
        //     text: "Kindly upload a logo",
        //   },
        // });
        this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Logo Needed',
                icon: 'BellIcon',
                variant: 'danger',
                text: "Kindly upload a logo",
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
        return false;
      }
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    fileSelected(e) {
      
      this.isFileSelected  = !this.isFileSelected;
    },
       removeLogo(imageKey) {
    const data = {
      params: {
        [`${imageKey}`]: true, // Dynamic key for removal
      },
    };
    this.$store
        .dispatch("app-setting/updateSettings", {
          data: data,
        })
        .then((res) => {
          if (res.data.success) {
            // this.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "Company Settings Updated",
            //     icon: "BellIcon",
            //     variant: "success",
            //     text: res.data.message,
            //   },
            // });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Company Settings Updated',
                icon: 'BellIcon',
                variant: 'success',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });
            // this.$router.push("/settings");
          } else {
            // this.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "Oops! Company updating Failed",
            //     icon: "BellIcon",
            //     variant: "danger",
            //     text: res.data.message,
            //   },
            // });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Oops! Company updating Failed',
                icon: 'BellIcon',
                variant: 'danger',
                text: res.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
          }
        })
        .catch((error) => {
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Oops! Company updating Failed",
          //     icon: "BellIcon",
          //     variant: "danger",
          //     text: error,
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Oops! Company updating Failed',
                icon: 'BellIcon',
                variant: 'danger',
                text: error,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
        });
  },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
// Import FilePond styles
@import "~filepond/dist/filepond.min.css";
@import "~filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
@import "@core/scss/vue/pages/page-auth.scss";
@import "~cropperjs/dist/cropper.css";
.filepond--credits {
  display: none;
}
.cropper-crop-box, .cropper-view-box {
    border-radius: 0% !important;
}

.cropper-view-box {
    box-shadow: 0 0 0 1px #39f;
    outline: 0;
}

.filepond--credits {
  display: none;
}
.close-crop-btn {
  position: absolute;
  top: 0;
  right: 0;
}
.btn-crop-container {
  display: flex;
  justify-content: center;
  align-content: flex-end;
}

</style>

<style lang="scss" scoped>
.assign-interview-btn {
  position: absolute;
  right: 180px;
  bottom: 60px;
  border: solid 1px;
}
span.rating-btn {
  width: 130px;
  margin-left: 5px;
  padding: 2px;
  color: #fff;
  border-radius: 2px;
  font-size: 13px;
  text-align: center;
  font-weight: 700;
  -webkit-transition: 0.2s;
  transition: 0.2s;
  line-height: 25px;
}
.star-belowAverage {
  background: #f5c357;
}
.star-poor {
  background: #bababa;
}
.star-average {
  background: #f3d23e;
}
.star-good {
  background: #c1d759;
}
.star-excellent {
  background: #48964d;
}
</style>
